export default __webpack_public_path__ + "static/before1-f74aeeb0bf437d63bfb7c634208f50b5.jpg";